import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = ({ className = '', variant = 'default' }) => {
  const { language, toggleLanguage } = useLanguage();

  const baseStyles = "flex items-center gap-1.5 font-medium transition-all duration-300";
  
  const variants = {
    default: "px-3 py-1.5 text-sm rounded-full border hover:bg-teal-50",
    header: "px-2 py-1 text-xs rounded-md",
    footer: "text-stone-300 hover:text-teal-400"
  };

  const getButtonStyles = () => {
    if (variant === 'header') {
      return `${baseStyles} ${variants.header} bg-white/80 border border-stone-200 text-stone-700 hover:border-teal-500 hover:text-teal-600`;
    }
    if (variant === 'footer') {
      return `${baseStyles} ${variants.footer}`;
    }
    return `${baseStyles} ${variants.default} border-stone-300 text-stone-700 hover:border-teal-500 hover:text-teal-600`;
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`${getButtonStyles()} ${className}`}
      aria-label={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
      data-testid="language-toggle"
    >
      <Globe size={variant === 'header' ? 14 : 16} />
      <span>{language === 'en' ? 'ES' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;
